import script from "./NewStudent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewStudent.vue?vue&type=script&setup=true&lang=ts"

import "./NewStudent.vue?vue&type=style&index=0&id=39941435&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39941435"]])

export default __exports__